// extracted by mini-css-extract-plugin
export default {"root":"root___gmdJb","title":"title___X1dn8","text":"text___IruK4","button":"button___EsWhS"};